module.exports = __webpack_public_path__ + "img/thc.bb5c7557.webp";